"use client";

import { useInspectorMode } from "@utils/ContentfulUtils";
import { useLiveQuery } from "dexie-react-hooks";
import { AnimatePresence, motion } from "framer-motion";
import dynamic from "next/dynamic";
import { getImageProps } from "next/image";
import Image from "next/image";
import React, { useContext, useRef, useState } from "react";

import { NavigationContext } from "@/context/NavigationContext";
import useBreakPoint from "@/hooks/useBreakpoint";
import { BaseEntry, Media, PRODUCT_TYPE, VISUAL_VARIANT } from "@/types";

export interface HeroFirstCard extends BaseEntry {
  video?: Media;
  video_mobile?: Media;
  backupVideoImage: Media;
  image?: Media;
  mobileImage?: Media;
  logo?: Media;
  logoScrollDownImage?: Media;
  displaySearchBar?: boolean;
}

interface Props {
  entry: HeroFirstCard;
}

export default function HeroFirstCard({ entry }: Props) {
  const inspectorMode = useInspectorMode(entry.id);
  const { isMd } = useBreakPoint("md");
  const { setDesktopPanelID } = useContext(NavigationContext);

  const poster = getImageProps({
    alt: "",
    width: 1024,
    height: 768,
    quality: 80,
    src: entry?.backupVideoImage?.url,
  });
  return (
    <div className="relative flex justify-center h-svh" {...inspectorMode.getProps("video")}>
      <div className="absolute z-10 w-full h-full img-overlay-homepage-hero"></div>
      {entry?.video && (
        <video className="videoHero" poster={poster.props.src} muted autoPlay loop playsInline>
          <source media={entry?.video_mobile ? "all and (orientation: landscape)" : undefined} src={entry?.video?.url} type="video/mp4" />
          {entry?.video_mobile && <source media="all and (orientation: portrait)" src={entry?.video_mobile?.url} type="video/mp4" />}
        </video>
      )}
      {!entry.video && (
        <Image
          src={isMd ? entry?.image?.url || "" : entry.mobileImage?.url || ""}
          width={isMd ? entry?.image?.width : entry?.mobileImage?.width}
          height={isMd ? entry?.image?.height : entry?.mobileImage?.height}
          className="h-full w-full"
          alt={entry?.image?.title || ""}
        />
      )}
      {entry?.logo ? (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 mb-xl">
          <div className="flex-col items-center hidden md:flex">
            <Image src={entry?.logo?.url} alt={entry?.logo?.title} width={310} height={157} />
          </div>
          <div className="flex flex-col items-center md:hidden">
            <Image src={entry?.logo?.url} alt={entry?.logo?.title} width={177} height={90} />
          </div>
          {entry?.logoScrollDownImage && (
            <div className="flex flex-col items-center mt-[20px]">
              <Image src={entry?.logoScrollDownImage?.url} alt={entry?.logoScrollDownImage?.title} width={177} height={90} />
            </div>
          )}
        </div>
      ) : entry?.displaySearchBar ? (
        <></>
      ) : (
        <></>
      )}
    </div>
  );
}
